export default function getUrl(value) {
  return process.env.VUE_APP_BACKEND_HOST + value;
}
